module.exports = __webpack_public_path__ + "img/offline.42181310.svg";